import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

interface IDistributorUser {
  username: string;
  email: string;
  distributorUserType: string;
  password?: string;
}
export default function useCreateDistributorUser() {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  async function execute(distributorUser: IDistributorUser) {
    try {
      setLoading(true);
      const response = await api.post(`v1/backoffice/distributor-users/`, {
        username: distributorUser.username,
        email: distributorUser.email,
        password: distributorUser.password,
        distributorUserType: distributorUser.distributorUserType,
      });

      if (response.status === 201) {
        history.push('/home/users');
        toast.success(
          ToastMessages.distributorUser.success.registerDistributorUser,
        );
      }
    } catch (error) {
      return toast.error(
        ToastMessages.distributorUser.error.registerDistributorUser,
      );
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
